import axios from 'axios';
import config from '../config';
var qs = require('qs');

// When the API rejects the stored token (e.g. after the server's signing
// secret changes), forget it and send the customer to the login page instead
// of leaving them "logged in" with every account call failing. Guests (no
// stored token) stay where they are: shop pages ask for a wishlist anyway.
export function handleAuthError(err) {
    const res = err && err.response;
    if (res && res.status === 403 && res.data && res.data.auth === false && localStorage.getItem('token')) {
        localStorage.removeItem('token');
        if (window.location.pathname !== '/register') {
            window.location.assign('/register');
        }
    }
    return Promise.reject(err);
}

const authed = axios.create();
authed.interceptors.response.use((response) => response, handleAuthError);


export function getAllObjects(objectName,query) {
    return axios.get(config.API_URL + objectName + '/',{
        params:query
    })
}

export function getWithQuery(objectName,url,query){
    const queryString = qs.stringify(query)
    return axios({
        method: 'GET',
        baseURL: config.API_URL+objectName+'/',
        url:url+"?"+queryString,    
    })
}
export function getSingleObject(objectName, object_id) {
    return axios({
        method: 'GET',
        baseURL: config.API_URL+objectName+'/'+object_id
    })
}

export function getObjectWithToken(objectName) {
    var options = {
        headers: {
            'Content-Type': 'application/json',
            'x-access-token': localStorage.getItem('token')
        }
    }
    return authed(config.API_URL+objectName+'/',options)
}

export function postObjectWithToken(objectName, body,progress) {
    var options = {
        headers: {
            'Content-Type': 'application/json',
            'x-access-token': localStorage.getItem('token')
        }
    }
    return authed.post(config.API_URL+objectName+'/',body, options)
}


export function postObject(objectName, body) {
    return axios.post(config.API_URL+objectName+ '/', body)
}

export function deleteObject(objectName, body) {
    return axios({
        method: 'DELETE',
        url:body._id,
        baseURL: config.API_URL+objectName+'/'
    })
}

export function updateObject(objectName, query, body) {
    body["_id"] = query._id
    return axios({
        method: 'PUT',
        url: config.API_URL+objectName,
        data: body
    })
}


export function updateObjectWithToken(objectName, body) {
    var headers = {
        'Content-Type': 'application/json',
        'x-access-token': localStorage.getItem('token')
    }
    return authed({
        method: 'PUT',
        url: config.API_URL+objectName,
        data: body,
        headers
    })
}

export function closeNotification(context) {
    setTimeout(function () {
        context.setState({
            isShowing: false,
        })
    }, 3000)
}

export function handleCatch(err,context) {
    context.setState({
        message: err.message,
        isShowing: true,
        status: 'ERROR!',
        alert: 'danger'
    })
}

export function toPrice(price) {
    if(!price && price !== 0) return null
    return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

export function getDesign(segmentId) {
    const designKey = segmentId?(segmentId.split(".")[1]):('')
    return (config.designs[designKey]?(config.designs[designKey]):(''))
}
// export function toBoxPrice(product,price) {
//     let boxSize = 1
//     if(product.boxSize){
//         boxSize = product.boxSize;
//     }
//     if(boxSize === 1 ){
//         return price;
//     }
//     return price * (product.size.length/100) * (product.size.width/100) * boxSize
// }

export function toBoxPrice(product,price) {
    let boxSize = 1
    if(product.boxSizeMeter){
        boxSize = product.boxSizeMeter;
    }
    if(boxSize === 1 ){
        return price;
    }
    return price * boxSize
}

export function toCloudinary(image,height,width){
    if(!image) return null
    const params = ["image=" + encodeURIComponent(image)]
    if(height) params.push("height=" + height)
    if(width) params.push("width=" + width)
    return "/img?" + params.join("&")
}